import { Avatar, Grid, Stack, Typography } from "@mui/material";
import { DispatchWithoutAction, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { trackEvent } from "src/Amplitude";
import Tick from "src/icons/Tick";
import { BrokerRes } from "src/store/features/api/generated";
import ContainedButton from "../common/ContainedButton";
import { TradeStyles } from "./styles/Trade.styles";
import useDeviceSizes from "../portfolio/hooks/useDeviceSizes";

export default function TradeSuccess(props: {
  toggle: DispatchWithoutAction;
  broker: BrokerRes | undefined;
}) {
  const { toggle, broker: { imgUrl, name } = {} } = props;
  const classes = TradeStyles();
  const history = useHistory();
  const { isTablet, isMobile } = useDeviceSizes();

  const message =
    "Thank you for being our loyal customer! I’m processing this order for you now. If you have any issues with your order or wish to cancel it, please feel free to contact me via phone or email.";

  useEffect(() => {
    trackEvent("Page_Order Placed Successfully", {}, "Trade");
  }, []);

  const imageDimensions = {
    width: isTablet ? "100px" : isMobile ? "90px" : "120px",
    height: isTablet ? "100px" : isMobile ? "90px" : "120px",
    top: isTablet ? -80 : isMobile ? -70 : -90,
  };

  return (
    <Grid
      id="trade-success"
      container
      height={"100%"}
      sx={{
        background: "#002035",
        borderRadius: "30px",
        padding: "24px",
        alignSelf: "flex-start",
      }}>
      {/* Order Placed */}
      <Grid item xs={12}>
        <Stack
          spacing={1}
          direction={"row"}
          justifyContent={"center"}
          alignItems={"center"}
          textAlign={"center"}>
          <Tick size="16px" color="#0BEC9F" tickColor="#002035" tickStroke="2.5" />
          <Typography fontWeight={"bold"} fontSize={"16px"} sx={{ color: "#FFF" }}>
            Order Placed!
          </Typography>
        </Stack>
      </Grid>
      {/* Broker message */}
      <Grid item xs={12} justifyContent="center" display="flex" mt={10}>
        <Grid item sx={{ position: "absolute" }}>
          <Avatar
            src={imgUrl}
            sx={{
              ...imageDimensions,
              position: "relative",
              border: "1px solid #002035",
            }}
          />
        </Grid>
        <Grid item xs={12} className={classes.messageContainer}>
          <div className={classes.messageContainerText}>{message}</div>
          <div className={classes.messageContainerBroker}>{`Your Broker, ${name}`}</div>
        </Grid>
      </Grid>
      {/* Buttons */}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          gap: "16px",
          paddingTop: "48px",
        }}>
        <ContainedButton
          color={"salmon"}
          borderRadius="10px"
          height="54px"
          onClick={() => {
            toggle();
            trackEvent("Button_Click", { page: "Placed_Add_Another_Order" }, "Trade");
          }}>
          <Typography fontWeight={"bold"} sx={{ color: "#FFF" }}>
            Add Another Trade
          </Typography>
        </ContainedButton>

        <ContainedButton
          color={"navy"}
          borderRadius="10px"
          height="54px"
          sx={{ border: "1px solid #FFF", boxShadow: "none" }}
          onClick={() => {
            history.push("/transactions/overview?trade");
            trackEvent(
              "Button_Click",
              {
                page: "Track_Your_Order",
              },
              "Trade",
            );
          }}>
          <Typography fontWeight={"bold"} sx={{ color: "#FFF" }}>
            Track your order
          </Typography>
        </ContainedButton>
      </div>
    </Grid>
  );
}
